var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _circle, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Oli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 1069,
    viewBox: "0 0 793 1069",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345 711.422C521.657 760.052 807.031 536.278 741.374 131.908C659.302 -373.555 630.595 750.474 345 711.422Z",
    fill: "#D24A4A",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.482 739.241C509.741 799.454 808.66 813.635 773.455 685.093C729.449 524.414 618.265 825.712 338.482 739.241Z",
    fill: "#D24A4A",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.327 762.224C464.659 900.164 716.766 1062.04 750.665 932.897C793.038 771.464 545.607 977.25 346.327 762.224Z",
    fill: "#D24A4A",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.51 529.251C256.8 508.944 299.606 499.564 342.198 502.148C385.027 504.747 477.81 518.938 441.951 568.777C423.724 594.109 405.567 586.172 382.678 576.166C369.34 570.335 354.394 563.801 336.891 562.739C305.341 560.825 273.633 567.773 245.269 582.815C216.906 597.857 192.992 620.408 176.171 647.975C159.349 675.543 150.635 707.056 150.311 739.028L90.3111 739.028C90.7497 695.866 102.519 654.431 125.228 617.216C147.937 580 180.22 549.557 218.51 529.251Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.51 948.41C256.8 968.716 299.606 978.096 342.198 975.512C385.027 972.913 477.81 958.722 441.951 908.883C423.724 883.551 405.567 891.488 382.678 901.494C369.34 907.325 354.394 913.859 336.891 914.921C305.341 916.835 273.633 909.887 245.269 894.845C216.906 879.803 192.992 857.252 176.171 829.685C159.349 802.117 150.635 770.604 150.311 738.632L90.3111 738.632C90.7497 781.794 102.519 823.229 125.228 860.444C147.937 897.66 180.22 928.103 218.51 948.41Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 729,
    rx: 41,
    ry: 22,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 729,
    rx: 41,
    ry: 22,
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.178,
    cy: 759.182,
    rx: 41,
    ry: 17.7521,
    transform: "rotate(90.5959 224.178 759.182)",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 623.5,
    r: 32.5,
    fill: "#D24A4A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 459.5,
    rx: 26.5,
    ry: 100.5,
    fill: "#D24A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Oli);
export default __webpack_public_path__ + "static/media/404 - Oli.ae12b095cbb9ac4174126cac47fefeb0.svg";
export { ForwardRef as ReactComponent };